// Resolved on use rather than captured in the constructor: the search input and
// reset button are re-rendered with the header, and a ref taken at upgrade time
// pointed at markup an A/B swap had already thrown away. The listeners are
// delegated on this element so they cover whichever input is currently inside.
class SearchForm extends HTMLElement {
  get input() {
    return this.querySelector('input[type="search"]');
  }

  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  connectedCallback() {
    // connectedCallback also fires on a plain move; these listeners live on the
    // element and survive it, so bind them only once.
    if (this._bound) return;
    this._bound = true;

    // `reset` fires on the form and bubbles, so one listener here covers a
    // re-rendered form as well as the original.
    ThemeBind.delegate(this, 'reset', 'form', this.onFormReset.bind(this));
    ThemeBind.delegate(
      this,
      'input',
      'input[type="search"]',
      debounce((event) => this.onChange(event), 300)
    );
  }

  toggleResetButton() {
    const input = this.input;
    const resetButton = this.resetButton;
    if (!input || !resetButton) return;
    const resetIsHidden = resetButton.classList.contains('hidden');
    if (input.value.length > 0 && resetIsHidden) {
      resetButton.classList.remove('hidden');
    } else if (input.value.length === 0 && !resetIsHidden) {
      resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      const input = this.input;
      if (!input) return;
      input.value = '';
      input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
